import { Camera, Id } from 'NSwag/ServerClient/Client.nswag';
import { CameraActionTypes, AddCameras, ModifyCameras, DeleteCameras } from 'Actions/ActionTypes/cameras';

/**
 * Function used to add cameras to an Action.
 * @param cameras - Array of cameras that were added.
 */
export const addCameras = (cameras: Camera[]): AddCameras => ({
    type: CameraActionTypes.AddCameras as CameraActionTypes.AddCameras,
    cameras
});

/**
 * Function used add a modified camera to an Action.
 * @param cameras - Array of cameras that were modified.
 */
export const modifyCameras = (cameras: Camera[]): ModifyCameras => ({
    type: CameraActionTypes.ModifyCameras as CameraActionTypes.ModifyCameras,
    cameras
});

/**
 * Function used to add a camera to an Action to be deleted.
 * @param ids - Camera ids to be deleted. 
 */
export const deleteCameras = (ids: Id[]): DeleteCameras => ({
    type: CameraActionTypes.DeleteCamera as CameraActionTypes.DeleteCamera,
    ids
});

export type CameraAction = ReturnType<typeof addCameras | typeof modifyCameras | typeof deleteCameras>;